
































































































import Vue, { PropOptions } from 'vue';
import util from '@/components/util';
import BasicGadget, {CFrame} from '@/components/gadgets/BasicGadget.vue';
import * as models from '@/class/models/views/graph';
import * as dashboard from '@/class/models/views/dashboard';
import Gadgets from '@/components/gadgets';
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import Muuri from 'muuri';
import API from '@/api/common';

export default Vue.extend({
  name: 'DashboardUpdateSp',
  components: {
    ...util, BasicGadget, ModalDeleteConfirm,
  },
  props: {
    indexs: Array as PropOptions<dashboard.IGadgetView[]>,
    slider: Number,
    individualGadgets: Object,
    clickItemText: String,
    clickItemJob: String,
  },
  data() {
    return {
      componentGadgets: Gadgets,
      frameData: new CFrame(),
      grid: {} as Muuri,
      trashGadgetShowFlag: false,
      trashGadgetKey: -1,
      largeGadget: {} as models.IGadget,
      largeGadgetActive: '',
      isShowLargeGadget: false,
    };
  },
  created() {
    // ガジェットを表示する前にtrueしないと一部縮小されない
    this.frameData.cover = true;
    this.frameData.noicons = true;
  },
  mounted() {
    this.grid = new Muuri('.grid-1', {
      dragEnabled: true,
      dragHandle: '.item .muuri-handle',
    });
    this.grid.on('move', (movedItem) => {
      // 移動中のつかんだ状態もここを通る
      // console.log('move',movedItem);
      this.$emit('onMoved', movedItem);
    });
    window.addEventListener('resize', this.pcHiddenScreen);
  },
  methods: {
    onClickAddGraph() {
      window.scrollTo(0, 0);
      this.$emit('addGraph');
    },
    onClickGadgetEdit(select: models.IGadget) {
      window.scrollTo(0, 0);
      this.$emit('edit', select, false, 1);
      this.$emit('close');
    },
    onClickComplete() {
      window.scrollTo(0, 0);
      this.$emit('complete');
    },
    getGadgetName(gadgetName: string) {
      // 第二次デザインで作られたグラフは新旧デザインを切り替える
      // 第三次デザインで作られたグラフはそのまま表示
      return gadgetName.indexOf('V3') === -1 ? gadgetName + 'V3' : gadgetName;
    },
    async registView(data: dashboard.IGadgetView) {
      // resizedがfalseで渡されることがあるのでtrueにする。(グラフが表示されないことに対する対応)
      for (const d of data.layout) {
        d.resized = true;
      }
      const api = new API();
      const res = await api.post<dashboard.IGadgetView, any>('dashboard/set', data);
    },
    trashGadget(index: number) {
      this.trashGadgetShowFlag = true;
      this.trashGadgetKey = index;
    },
    trashGadgetAfter() {
      this.indexs[this.slider].layout = this.indexs[this.slider].layout.filter((v) => (v.i !== this.trashGadgetKey));
      this.registView(this.indexs[this.slider]);
    },
    closeTrashGadgetModal() {
      this.trashGadgetShowFlag = false;
      this.trashGadgetKey = -1;
      this.$nextTick(() => {
        this.grid.refreshItems();
        this.grid.layout();
      });
    },
    showLargeGadget(gadget: models.IGadget, active: string) {
      // console.log('show large gadget', gadget.gadgetID, active);
      this.largeGadget = gadget;
      this.largeGadgetActive = active;
      this.isShowLargeGadget = true;
    },
    pcHiddenScreen() {
      if (window.innerWidth >= 960) {
        this.onClickComplete();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pcHiddenScreen);
  },
});

